<template>
  <div class="pcoded-inner-content">
    <create-edit-users
      :editedUser="editedUser"
      :companies="companies"
      @addUser="addUser = $event"
      @sendUsers="users = $event"
      @removeEdit="editedUser = $event"
    />
    <div class="col-lg-6 filter1 pl-4">
      <div
        class="page-header-title d-flex align-items-center position-relative"
      >
        <input
          v-model="search"
          class="filter_input"
          type="text"
          placeholder="MENO A EMAIL"
        />
        <svg
          class="filter_svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
        >
          <mask id="path-1-inside-1" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.4947 4.42476C13.4129 6.41116 13.3577 9.5765 11.3713 11.4947C9.38488 13.413 6.21953 13.3577 4.30129 11.3713C2.38304 9.38494 2.43829 6.2196 4.4247 4.30135C6.4111 2.38311 9.57644 2.43836 11.4947 4.42476ZM13.5589 12.0175C15.5266 9.32026 15.3321 5.51944 12.9334 3.03544C10.2478 0.254479 5.81634 0.177127 3.03538 2.86267C0.254416 5.54822 0.177064 9.9797 2.86261 12.7607C5.31231 15.2974 9.21474 15.5845 11.992 13.5771L12.9187 14.5367L13.4306 15.0667L14.8199 16.5054L14.9713 16.3592L16.2586 15.1161L16.41 14.9699L15.0207 13.5312L14.5088 13.0011L13.5589 12.0175Z"
            />
          </mask>
          <path
            d="M13.5589 12.0175L11.9432 10.8388L10.9522 12.1972L12.1203 13.4068L13.5589 12.0175ZM11.992 13.5771L13.4307 12.1878L12.226 10.9402L10.8204 11.9562L11.992 13.5771ZM12.9187 14.5367L14.3574 13.1474L12.9187 14.5367ZM13.4306 15.0667L11.9919 16.4561L13.4306 15.0667ZM14.8199 16.5054L13.3812 17.8947L14.7705 19.3334L16.2092 17.9441L14.8199 16.5054ZM14.9713 16.3592L13.582 14.9205L14.9713 16.3592ZM16.2586 15.1161L17.6479 16.5548L16.2586 15.1161ZM16.41 14.9699L17.7993 16.4085L19.238 15.0192L17.8487 13.5805L16.41 14.9699ZM15.0207 13.5312L13.582 14.9205L15.0207 13.5312ZM14.5088 13.0011L15.9475 11.6118L14.5088 13.0011ZM12.7606 12.9334C15.5416 10.2479 15.6189 5.8164 12.9334 3.03544L10.056 5.81408C11.207 7.00592 11.1738 8.90512 9.98196 10.0561L12.7606 12.9334ZM2.86261 12.7607C5.54815 15.5416 9.97963 15.619 12.7606 12.9334L9.98196 10.0561C8.79012 11.207 6.89092 11.1739 5.73997 9.98203L2.86261 12.7607ZM3.03538 2.86267C0.254416 5.54822 0.177064 9.9797 2.86261 12.7607L5.73997 9.98203C4.58902 8.79018 4.62217 6.89098 5.81401 5.74003L3.03538 2.86267ZM12.9334 3.03544C10.2478 0.254479 5.81634 0.177127 3.03538 2.86267L5.81401 5.74003C7.00585 4.58908 8.90506 4.62223 10.056 5.81408L12.9334 3.03544ZM15.1747 13.1962C17.7054 9.72716 17.4576 4.84131 14.372 1.64612L11.4947 4.42476C13.2067 6.19756 13.3478 8.91336 11.9432 10.8388L15.1747 13.1962ZM14.372 1.64612C10.9192 -1.9294 5.22159 -2.02885 1.64606 1.42399L4.4247 4.30135C6.4111 2.38311 9.57644 2.43836 11.4947 4.42476L14.372 1.64612ZM1.64606 1.42399C-1.92946 4.87684 -2.02891 10.5745 1.42393 14.15L4.30129 11.3713C2.38304 9.38494 2.43829 6.2196 4.4247 4.30135L1.64606 1.42399ZM1.42393 14.15C4.57473 17.4127 9.59131 17.7801 13.1636 15.198L10.8204 11.9562C8.83818 13.389 6.04988 13.1821 4.30129 11.3713L1.42393 14.15ZM10.5533 14.9664L11.48 15.926L14.3574 13.1474L13.4307 12.1878L10.5533 14.9664ZM11.48 15.926L11.9919 16.4561L14.8693 13.6774L14.3574 13.1474L11.48 15.926ZM11.9919 16.4561L13.3812 17.8947L16.2586 15.1161L14.8693 13.6774L11.9919 16.4561ZM16.2092 17.9441L16.3606 17.7979L13.582 14.9205L13.4306 15.0667L16.2092 17.9441ZM16.3606 17.7979L17.6479 16.5548L14.8693 13.6774L13.582 14.9205L16.3606 17.7979ZM17.6479 16.5548L17.7993 16.4085L15.0207 13.5312L14.8693 13.6774L17.6479 16.5548ZM17.8487 13.5805L16.4594 12.1419L13.582 14.9205L14.9713 16.3592L17.8487 13.5805ZM16.4594 12.1419L15.9475 11.6118L13.0702 14.3905L13.582 14.9205L16.4594 12.1419ZM15.9475 11.6118L14.9976 10.6282L12.1203 13.4068L13.0702 14.3905L15.9475 11.6118Z"
            fill="#DDE3E8"
            mask="url(#path-1-inside-1)"
          />
        </svg>
      </div>
      <div
        class="page-header-title d-flex align-items-center position-relative"
        style="margin-left: 20px"
      >
        <input
          v-model="search_firma"
          class="filter_input"
          type="text"
          placeholder="NÁZOV FIRMY"
        />
        <svg
          class="filter_svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
        >
          <mask id="path-1-inside-1" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.4947 4.42476C13.4129 6.41116 13.3577 9.5765 11.3713 11.4947C9.38488 13.413 6.21953 13.3577 4.30129 11.3713C2.38304 9.38494 2.43829 6.2196 4.4247 4.30135C6.4111 2.38311 9.57644 2.43836 11.4947 4.42476ZM13.5589 12.0175C15.5266 9.32026 15.3321 5.51944 12.9334 3.03544C10.2478 0.254479 5.81634 0.177127 3.03538 2.86267C0.254416 5.54822 0.177064 9.9797 2.86261 12.7607C5.31231 15.2974 9.21474 15.5845 11.992 13.5771L12.9187 14.5367L13.4306 15.0667L14.8199 16.5054L14.9713 16.3592L16.2586 15.1161L16.41 14.9699L15.0207 13.5312L14.5088 13.0011L13.5589 12.0175Z"
            />
          </mask>
          <path
            d="M13.5589 12.0175L11.9432 10.8388L10.9522 12.1972L12.1203 13.4068L13.5589 12.0175ZM11.992 13.5771L13.4307 12.1878L12.226 10.9402L10.8204 11.9562L11.992 13.5771ZM12.9187 14.5367L14.3574 13.1474L12.9187 14.5367ZM13.4306 15.0667L11.9919 16.4561L13.4306 15.0667ZM14.8199 16.5054L13.3812 17.8947L14.7705 19.3334L16.2092 17.9441L14.8199 16.5054ZM14.9713 16.3592L13.582 14.9205L14.9713 16.3592ZM16.2586 15.1161L17.6479 16.5548L16.2586 15.1161ZM16.41 14.9699L17.7993 16.4085L19.238 15.0192L17.8487 13.5805L16.41 14.9699ZM15.0207 13.5312L13.582 14.9205L15.0207 13.5312ZM14.5088 13.0011L15.9475 11.6118L14.5088 13.0011ZM12.7606 12.9334C15.5416 10.2479 15.6189 5.8164 12.9334 3.03544L10.056 5.81408C11.207 7.00592 11.1738 8.90512 9.98196 10.0561L12.7606 12.9334ZM2.86261 12.7607C5.54815 15.5416 9.97963 15.619 12.7606 12.9334L9.98196 10.0561C8.79012 11.207 6.89092 11.1739 5.73997 9.98203L2.86261 12.7607ZM3.03538 2.86267C0.254416 5.54822 0.177064 9.9797 2.86261 12.7607L5.73997 9.98203C4.58902 8.79018 4.62217 6.89098 5.81401 5.74003L3.03538 2.86267ZM12.9334 3.03544C10.2478 0.254479 5.81634 0.177127 3.03538 2.86267L5.81401 5.74003C7.00585 4.58908 8.90506 4.62223 10.056 5.81408L12.9334 3.03544ZM15.1747 13.1962C17.7054 9.72716 17.4576 4.84131 14.372 1.64612L11.4947 4.42476C13.2067 6.19756 13.3478 8.91336 11.9432 10.8388L15.1747 13.1962ZM14.372 1.64612C10.9192 -1.9294 5.22159 -2.02885 1.64606 1.42399L4.4247 4.30135C6.4111 2.38311 9.57644 2.43836 11.4947 4.42476L14.372 1.64612ZM1.64606 1.42399C-1.92946 4.87684 -2.02891 10.5745 1.42393 14.15L4.30129 11.3713C2.38304 9.38494 2.43829 6.2196 4.4247 4.30135L1.64606 1.42399ZM1.42393 14.15C4.57473 17.4127 9.59131 17.7801 13.1636 15.198L10.8204 11.9562C8.83818 13.389 6.04988 13.1821 4.30129 11.3713L1.42393 14.15ZM10.5533 14.9664L11.48 15.926L14.3574 13.1474L13.4307 12.1878L10.5533 14.9664ZM11.48 15.926L11.9919 16.4561L14.8693 13.6774L14.3574 13.1474L11.48 15.926ZM11.9919 16.4561L13.3812 17.8947L16.2586 15.1161L14.8693 13.6774L11.9919 16.4561ZM16.2092 17.9441L16.3606 17.7979L13.582 14.9205L13.4306 15.0667L16.2092 17.9441ZM16.3606 17.7979L17.6479 16.5548L14.8693 13.6774L13.582 14.9205L16.3606 17.7979ZM17.6479 16.5548L17.7993 16.4085L15.0207 13.5312L14.8693 13.6774L17.6479 16.5548ZM17.8487 13.5805L16.4594 12.1419L13.582 14.9205L14.9713 16.3592L17.8487 13.5805ZM16.4594 12.1419L15.9475 11.6118L13.0702 14.3905L13.582 14.9205L16.4594 12.1419ZM15.9475 11.6118L14.9976 10.6282L12.1203 13.4068L13.0702 14.3905L15.9475 11.6118Z"
            fill="#DDE3E8"
            mask="url(#path-1-inside-1)"
          />
        </svg>
      </div>
    </div>
    <div class="main-body">
      <div class="page-wrapper">
        <div class="page-body">
          <div class="row">
            <div class="col-md-12">
              <div v-if="!search_users" class="card table-card">
                <div class="card-block" style="padding-bottom: 0px">
                  <div class="table-responsive">
                    <table
                      class="table table-hover"
                      style="margin-bottom: 0rem"
                    >
                      <thead>
                        <tr>
                          <th>E-mail</th>
                          <th>Meno a priezvisko</th>
                          <th>Názov firmy</th>
                          <th>Company slug</th>
                          <th>Počet ponúk</th>
                          <th>Celková cena ponúk</th>
                          <th>Priemerná cena ponúk</th>
                          <th>Oblasť</th>
                          <th>Status</th>
                          <th>Balík</th>
                          <th>Rola</th>
                          <th>Posledné použitie</th>
                          <th>Akcie</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="user in filteredItems" :key="user.id">
                          <td>
                            <div class="d-inline-block align-middle">
                              <div class="d-inline-block">
                                <h6>
                                  {{ user.email }}
                                  <!-- <br />
                                  <small
                                    v-show="user.premium"
                                    class="info_premium"
                                    style="cursor: pointer"
                                    @click="setDetail(user)"
                                  >
                                    zobraziť fakturačné údaje
                                  </small> -->
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-inline-block align-middle">
                              <div class="d-inline-block">
                                <h6>
                                  {{ user.meno }}
                                  {{ user.priezvisko }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-inline-block align-middle">
                              <div class="d-inline-block">
                                <h6>
                                  {{ user.firma[0] }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-inline-block align-middle">
                              <div class="d-inline-block">
                                <h6>
                                  {{ user.slug[0] }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-inline-block align-middle">
                              <div class="d-inline-block">
                                <h6>
                                  {{ user.offer_count }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-inline-block align-middle">
                              <div class="d-inline-block">
                                <h6>
                                  {{
                                    formatNumber(user.total_offer_price) +
                                    " " +
                                    "€"
                                  }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-inline-block align-middle">
                              <div class="d-inline-block">
                                <h6>
                                  {{
                                    formatNumber(user.avg_offer_price) +
                                    " " +
                                    "€"
                                  }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td style="width: 100px">
                            <div class="d-inline-block align-middle">
                              <div class="d-inline-block">
                                <h6
                                  v-for="(area, index) in user.businessArea"
                                  :key="area.id"
                                >
                                  {{ area.title }}
                                  <span
                                    v-if="index < user.businessArea.length - 1"
                                    >,</span
                                  >
                                </h6>
                                <h6 v-if="user.businessArea.length <= 0">
                                  N/A
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td style="white-space: normal; width: 200px">
                            <label
                              v-show="user.status == 0"
                              class="label label-warning"
                              >Neaktivovaný</label
                            >
                            <label
                              v-show="user.status == 1"
                              class="label label-success"
                              >Aktivovaný</label
                            >
                            <label
                              v-show="user.status == 2"
                              class="label label-danger"
                              >Zablokovaný</label
                            >
                          </td>
                          <td style="white-space: normal; width: 150px">
                            <label
                              v-show="user.premium"
                              class="label label-danger"
                              >{{ user.premium }}</label
                            >
                          </td>
                          <td style="white-space: normal; width: 200px">
                            <label
                              v-show="user.role[0] == 1"
                              class="label label-danger"
                              >Admin</label
                            >
                            <label
                              v-show="user.role[0] == 2"
                              class="label label-info"
                              >Company owner</label
                            >
                            <label
                              v-show="user.role[0] == 3"
                              class="label label-success"
                              >Company worker</label
                            >
                          </td>
                          <td>
                            <div class="d-inline-block align-middle">
                              <div class="d-inline-block">
                                <h6
                                  v-if="user.date_action"
                                  style="width: 100px"
                                >
                                  {{ user.date_action }}
                                </h6>
                                <h6 v-if="!user.date_action">NaN</h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <button
                              title="Upraviť používatela"
                              class="my_tooltip"
                              style="
                                border: none;
                                cursor: pointer;
                                outline: none;
                                background-color: transparent;
                              "
                              @click="editUser(user)"
                            >
                              <span class="my_tooltiptext"
                                >Upraviť používatela</span
                              >
                              <i
                                class="icon feather icon-edit f-w-600 f-16 m-r-15 text-c-green"
                              ></i>
                            </button>
                            <button
                              title="Vymazať používatela"
                              class="my_tooltip"
                              style="
                                border: none;
                                cursor: pointer;
                                outline: none;
                                background-color: transparent;
                              "
                              @click="deleteUser(user.id)"
                            >
                              <span class="my_tooltiptext"
                                >Vymazať používatela</span
                              >
                              <i
                                class="feather icon-trash-2 f-w-600 f-16 text-c-red"
                              ></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div v-if="!search_users">
                <button class="mt-5 zobrazitViac" @click="show_more_users">
                  <span v-show="show_user_btn">
                    Načítať ďaľších používateľov
                  </span>
                  <div v-show="!show_user_btn" class="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </button>
              </div>
              <div v-if="search_users">
                <div class="lds-ellipsis green">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="detail" class="detail">
      <div class="box">
        <div class="d-flex justify-content-between">
          <h3>Fakturačné údaje</h3>
          <span @click="detail = false" style="cursor: pointer">X</span>
        </div>
        <h5 v-if="!detail_user.ico">Fyzická osoba</h5>
        <h5 v-else>Firma / živnostník</h5>
        <p><b> Meno a priezvisko: </b> {{ detail_user.name }}</p>
        <div v-if="detail_user.ico">
          <p><b> Názov spoločnosti: </b> {{ detail_user.company }}</p>
          <p><b> IČO: </b> {{ detail_user.ico }}</p>
          <p><b> DIČ: </b> {{ detail_user.dic }}</p>
          <p><b> IČ DPH: </b> {{ detail_user.icdph }}</p>
        </div>
        <p><b> Ulica a číslo: </b> {{ detail_user.address }}</p>
        <p>
          <b> Mesto a PSČ: </b> {{ detail_user.town }}
          {{ detail_user.psc }}
        </p>
        <p v-if="detail_user.code != null">
          <b>Code: </b> {{ detail_user.code }}
        </p>
        <p>
          <b>Doba predpatneho: </b>
          {{ moment(detail_user.created_at).format("DD.MM.YYYY") }} -
          {{
            moment(detail_user.created_at).add(1, "year").format("DD.MM.YYYY")
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CreateEditUsers from "./components/CreateEditUsers.vue";
import swal from "sweetalert2/dist/sweetalert2.all.min.js";
import moment from "moment";
export default {
  props: ["companies", "firstusers"],
  components: { CreateEditUsers, moment },
  data() {
    return {
      show_users_offset: 0,
      show_users_limit: 20,
      search_users: false,
      show_user_btn: true,
      addUser: false,
      editedUser: {},
      data_show: null,
      search: "",
      search_firma: "",
      searchEmailShow: false,
      searchEmail: "",
      searchLastnameShow: false,
      searchLastname: "",
      searchFirmaShow: false,
      searchFirma: "",
      users: [],
      detail: false,
      detail_user: {},
      moment: moment,
    };
  },
  created() {
    this.users = this.firstusers;
    this.data_show = this.users;
    // axios.get("/api/users").then(response => {
    //     this.users = response.data;
    // });
  },
  methods: {
    show_more_users() {
      var offset = this.show_users_offset + this.show_users_limit;
      var limit = this.show_users_limit;
      this.show_user_btn = false;
      axios
        .get("/api/users/byCount/" + offset + "/" + limit + "")
        .then((response) => {
          this.show_users_offset += this.show_users_limit;
          if (response.data && response.data.length > 0) {
            response.data.forEach((o) => {
              this.users.push(o);
            });
          }
          this.show_user_btn = true;
        });
    },
    setDetail(user) {
      this.detail_user = user.PaymentHistory;
      this.detail = true;
    },
    formatNumber(value) {
      return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    editUser(user) {
      this.editedUser = user;
    },
    deleteUser(id) {
      swal
        .fire({
          title: "Určite?",
          text: "Vymazať uživateľa?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "Nie",
          confirmButtonText: "Áno",
        })
        .then((result) => {
          if (result.value) {
            axios.delete("/api/users/" + id).then((response) => {
              this.users = this.users.filter((e) => e.id !== id);
              this.$toast.success("Uživateľ bol odstránený.", {
                timeout: 3038,
              });
            });
          }
        });
    },
    debounceInput: _.debounce(function (e) {
      if (this.search || this.search_firma) {
        axios
          .get(
            "/api/users/bySearch" +
              "/" +
              (this.search ? this.search : "null") +
              "/" +
              (this.search_firma ? this.search_firma : "null")
          )
          .then((response) => {
            // This returns 10 best match result from the database
            this.search_users = false;
            this.data_show = response.data;
          });
      } else {
        this.search_users = false;
        this.data_show = this.users;
      }
    }, 1000),
    startSearching() {
      if (!this.search && !this.search_firma) {
        this.search_users = false;
        this.data_show = this.users;
      } else {
        this.search_users = true;
        this.debounceInput();
      }
    },
  },
  watch: {
    search_firma() {
      this.startSearching();
    },
    search() {
      this.startSearching();
    },
  },
  computed: {
    filteredItems() {
      return this.data_show;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 0;
  @media only screen and (max-width: 600px) {
    display: grid;
  }
  .filter_svg {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 15px;
    cursor: pointer;
  }
  .filter_svg2 {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 15px;
    cursor: pointer;
  }
  .filter_input {
    width: 300px;
    height: 55px;
    background: #ffffff;
    border: 1px solid #dde3e8;
    box-sizing: border-box;

    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;

    color: #9598a7;

    padding: 15px;
  }
  .d-inline h5 {
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: #212541;
  }
  .combobox_mojefirmy_search {
    margin-left: 30px;
    position: relative;
    .v-menu {
      .v-menu__content {
        left: 0 !important;
      }
    }
    .v-input {
      width: 300px;
      height: 55px;
    }
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
      background: #fff;
    }
    input {
      font-family: Roboto !important;
      font-style: normal !important;
      font-weight: bold !important;
      font-size: 14px !important;
      line-height: 16px !important;
      color: #212541 !important;
    }
    .v-input__slot,
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
      background: #fff !important;
      border: 1px solid #dde3e8 !important;
      border-radius: 0 !important;
      input {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #212541 !important;
      }
    }

    .v-text-field > .v-input__control > .v-input__slot {
      &:after {
        content: none !important;
      }
      &:before {
        content: none !important;
      }
    }
    .v-label.v-label--active.theme--light {
      left: -11px !important;
      top: 14px !important;
      font-family: Roboto !important;
      font-style: normal !important;
      font-weight: bold !important;
      font-size: 11px !important;
      line-height: 13px !important;
      letter-spacing: 0.1em !important;
      text-transform: uppercase !important;
      color: #9598a7 !important;
      margin-top: 0 !important;
    }
    .v-label.theme--light {
      top: 22px !important;
      font-family: Roboto !important;
      font-style: normal !important;
      font-weight: bold !important;
      font-size: 11px !important;
      line-height: 13px !important;
      letter-spacing: 0.1em !important;
      text-transform: uppercase !important;
      color: #9598a7 !important;
      margin-top: 0 !important;
    }
  }
}
.zobrazitViac {
  width: 250px;
  height: 55px;
  background: #2ed8b6;
  border-radius: 4px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  transition: 0.5s all;
  &:focus {
    outline: none;
  }
  &:hover {
    background: #23caa9;
    color: #ffffff;
  }
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis.green div {
  background: #2ed8b6;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

@media (max-width: 1200px) {
  .page-header.card {
    margin-left: 30px !important;
    .row:first-child {
      flex-direction: column;
      align-items: start !important;
    }
  }
  .offer_count {
    order: 1;
  }
  .filter1 {
    order: 3;
  }
  .filter2 {
    order: 2;
    justify-content: flex-start;
  }
}
@media (max-width: 1000px) {
  .page-header.card {
    margin-left: 10px !important;
  }
}
.info_premium {
  font-size: 12px;
  text-decoration: underline;
}
.detail {
  position: fixed;
  z-index: 100000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.4);
  .box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: white;
    width: 500px;
    height: fit-content;
    border-radius: 4px;
    padding: 20px;
  }
}
.card-block {
  overflow: hidden;
}
</style>
